import React from 'react'

const Blogs = () => {
  return (
    <div>
      Blog page
    </div>
  )
}

export default Blogs
